import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FormattedMessagePropType } from '../../../prop-types/intl';
import { ButtonThemeService } from 'ui-components/services/button-theme-service';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';

import ModalPortal from '../../modal-portal';
import styles from './style.module.less';

const defaultMessage = <FormattedMessage defaultMessage='Continue' description='Confirmation modal continue button message' id='2f51C+' />;

export const ConfirmDialogueModal = ({
  body,
  buttonDisabled = false,
  buttonMessage = defaultMessage,
  buttonTheme = 'primary',
  header,
  onClose,
  onConfirm,
  size = 'small',
}) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal size={size}>
        <ModalHeader>{header}</ModalHeader>
        <ModalBody className={styles['modal-body']}>{body}</ModalBody>
        <ModalFooter>
          <ModalFooterCancelButton />
          <Button disabled={buttonDisabled} onClick={onConfirm} theme={buttonTheme}>
            {buttonMessage}
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

ConfirmDialogueModal.propTypes = {
  body: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  buttonDisabled: PropTypes.bool,
  buttonMessage: FormattedMessagePropType,
  buttonTheme: PropTypes.oneOf(ButtonThemeService.getButtonThemes()),
  header: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
